import React, { useState, useEffect } from 'react';
import { message, Modal } from 'components/shared/AntComponent';
import { Form, Input, DatePicker, Select } from 'components/shared/FormComponent';
import { useDispatch } from 'react-redux';
import { saveBatchDetails } from 'services/store/actions/masterDataAction';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

interface ChildProps {
    openModal: boolean;
    rowData: any;
    closeModal: () => void;
    callbackFunc: () => void;
}

const AddBatchModal: React.FC<ChildProps> = ({ openModal, rowData, closeModal, callbackFunc }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { success1, error1, loading1 } = useSelector((state: any) => state.master);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error1 : false;
    const statusOptions = [
        {
            label: 'Completed',
            value: 'Completed',
        },
        {
            label: 'Ongoing',
            value: 'Ongoing',
        },
        {
            label: 'Yet to start',
            value: 'Yet to Start',
        },
    ];
    const submitBatchForm = async () => {
        try {
            await form.validateFields();
            const value = form.getFieldsValue();
            const inputJson = {
                batch_id: rowData ? rowData?.id : 0,
                batch_name: value.batchname || '',
                description: value.description || '',
                batch_st_date: value['startDate']?.format('YYYY-MM-DD') || '',
                batch_en_date: value['endDate']?.format('YYYY-MM-DD') || null,
                mode_of_applied: null,
                associated_candidates: null,
                associated_trainers: null,
                feedback: null,
                batch_amount: 5000,
                status: 'Completed',
            };
            dispatch(saveBatchDetails(inputJson) as any);
            setShowErrormsg(true);
            setShowSuccessmsg(true);
        } catch (error: any) {
            console.log('error', error);
        }
    };

    useEffect(() => {
        if (successmsg) {
            message.success(`Batch ${rowData ? 'updated' : 'created'} successfully`);
            setShowSuccessmsg(false);
            callbackFunc();
            closeModal();
            form.resetFields();
        }
        if (errormsg) {
            if (error1?.data) {
                message.error(error1?.data);
            } else {
                message.error(`Batch couldn't be ${rowData ? 'updated' : 'created'}`);
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    const loadData = () => {
        form.setFieldsValue({
            batchname: rowData?.batch_name || '',
            description: rowData?.description || '',
            startDate: rowData ? dayjs(rowData?.batch_st_date) : '',
            endDate: rowData ? dayjs(rowData?.batch_en_date) : '',
            fee: rowData?.batch_amount || '',
            status: rowData?.status || '',
        });
    };

    useEffect(() => {
        if (openModal) {
            loadData();
        }
    }, [openModal]);

    return (
        <div>
            <Modal
                title={rowData ? 'Update Batch' : 'Create Batch'}
                confirmLoading={loading1}
                open={openModal}
                okText={rowData ? 'Update' : 'Save'}
                onCancel={() => closeModal()}
                onOk={submitBatchForm}
            >
                <Form form={form} layout="vertical">
                    <Form.Item name="batchname" label="Batch Name" rules={[{ required: true, message: 'This field is required' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="description" label="Description" rules={[{ required: true, message: 'This field is required' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="startDate" label="Start Date" rules={[{ required: true, message: 'This field is required' }]}>
                        <DatePicker className="w-100" format="MM-DD-YYYY" />
                    </Form.Item>
                    <Form.Item name="endDate" label="End Date" rules={[{ required: true, message: 'This field is required' }]}>
                        <DatePicker className="w-100" format="MM-DD-YYYY" />
                    </Form.Item>
                    <Form.Item name="fee" label="Fee per individual" rules={[{ required: true, message: 'This field is required' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="status" label="Status" rules={[{ required: true, message: 'This field is required' }]}>
                        <Select options={statusOptions} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default AddBatchModal;
